import React, { lazy } from 'react';
import { MenuItem } from '../data/menu';
import { useOrder } from '../context/OrderContext';
import { useLanguage } from '../context/LanguageContext';
import { QuantityStepper } from './QuantityStepper';
import { motion } from 'framer-motion';
interface MenuItemCardProps {
  item: MenuItem;
}
export const MenuItemCard = ({
  item
}: MenuItemCardProps) => {
  const {
    cart,
    updateQuantity,
    addToCart
  } = useOrder();
  const {
    t,
    language
  } = useLanguage();
  const cartItem = cart.find(ci => ci.item.id === item.id);
  const quantity = cartItem?.quantity || 0;
  const handleQuantityChange = (newQty: number) => {
    if (newQty > 0 && quantity === 0) {
      addToCart(item, newQty);
    } else {
      updateQuantity(item.id, newQty);
    }
  };
  const itemName = language === 'en' ? item.nameEn : item.name;
  const itemDesc = language === 'en' ? item.descriptionEn : item.description;
  return <motion.div layout initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="bg-white p-4 rounded-2xl shadow-soft border border-border/50 flex flex-col gap-3" data-id="element-24">
      <div className="flex justify-between items-start gap-4" data-id="element-25">
        {item.image && <img src={item.image} alt={itemName} loading="lazy" className="w-20 h-20 rounded-xl object-cover shrink-0 bg-cream-dark" data-id="element-26" />}
        <div className="flex-1" data-id="element-27">
          <h3 className="font-serif text-lg font-medium text-espresso leading-tight mb-1" data-id="element-28">
            {itemName}
          </h3>
          {itemDesc && <p className="text-sm text-espresso-light/80 leading-relaxed mb-2" data-id="element-29">
              {itemDesc}
            </p>}
        </div>
      </div>

      <div className="flex items-center justify-between mt-auto pt-2 border-t border-cream-dark" data-id="element-30">
        <div className="flex flex-col" data-id="element-31">
          <span className="font-medium text-terracotta-dark" data-id="element-32">
            {item.price} kr
          </span>
          {item.isRoll && <span className="text-[11px] text-espresso-light uppercase tracking-wider font-medium" data-id="element-33">
              {t('menu.or_bundle')}
            </span>}
        </div>

        <QuantityStepper quantity={quantity} onChange={handleQuantityChange} data-id="element-34" />
      </div>
    </motion.div>;
};